import { z } from 'zod';
const baseGuDetailsSection = z.object({
    wnl: z.boolean().optional(),
    details: z.array(z.string()).optional(),
    catheter: z.string().optional(),
    frSize: z.string().optional(),
    balloonSize: z.string().optional(),
    inserted: z.string().optional(),
    date: z.string().optional(),
    urineColor: z.string().optional(),
    urinaryFrequency: z.string().optional(),
});
export const baseGuDetailsSectionRefined = baseGuDetailsSection.refine((data) => data.wnl ||
    data.details?.length ||
    data.catheter?.trim() ||
    data.frSize?.trim() ||
    data.balloonSize?.trim() ||
    data.inserted?.trim() ||
    data.date?.trim() ||
    data.urineColor?.trim() ||
    data.urinaryFrequency?.trim(), { message: 'At least one answer is required', path: [] });
const baseClinicalNarrativeSection = z.object({
    wnl: z.boolean().optional(),
    narrative: z.string().optional(),
});
export const baseClinicalNarrativeSectionRefined = baseClinicalNarrativeSection.refine((data) => data.wnl || data.narrative?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const baseGenitourinarySchema = z.object({
    guDetails: baseGuDetailsSection.optional(),
    clinicalNarrative: baseClinicalNarrativeSection.optional(),
});
export const baseGenitourinarySchemaRefined = z.object({
    guDetails: baseGuDetailsSectionRefined,
    clinicalNarrative: baseClinicalNarrativeSectionRefined,
});
